<template>
  
 <div v-if="showState == SHOW_START_ASR" :key="showTrigger">
    <StartASRView :startASRStatus="startASRStatus" :startASRStatusTrigger="startASRStatusTrigger"
            @where-next="whereNext" @string-to-speak="stringToSpeak"
            ></StartASRView>
  </div>

  <div v-if="showState == SHOW_MAIN" :key="showTrigger">
    <MainMenuView @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
                  :welcomeMessage="mainScreenMessage"
                  >
    </MainMenuView>
  </div>
  <div v-if="showState == SHOW_ENGINE_MENU" :key="showTrigger">
    <EngineMenuView @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger">
    </EngineMenuView>
  </div>
  <div v-if="showState == SHOW_VERBAL_PLAY" :key="showTrigger">
    <VerbalPlayView  
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  @string-to-speak="stringToSpeak"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger">
    </VerbalPlayView>
  </div>
  <div v-if="showState == SHOW_GAME_HISTORY" :key="showTrigger">
    <GameHistoryView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
  </GameHistoryView>
  </div>
  <div v-if="showState == SHOW_GAME_REVIEW" :key="showTrigger">
    <GameReviewView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </GameReviewView>
  </div>

  <div v-if="showState == SHOW_ACCOUNT_MENU" :key="showTrigger">
    <AccountMenuView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </AccountMenuView>
  </div>
  <div v-if="showState == SHOW_BOARD_PREFERENCES" :key="showTrigger">
    <BoardPreferencesView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </BoardPreferencesView>
  </div>
  <div v-if="showState == SHOW_VOICES_MENU" :key="showTrigger">
    <VoicesMenuView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </VoicesMenuView>
  </div>
  <div v-if="showState == SHOW_LOG_ON" :key="showTrigger">
    <LoginView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </LoginView>
  </div>
  <div v-if="showState == SHOW_LOG_OFF" :key="showTrigger">
    <LogoffView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </LogoffView>
  </div>
  <div v-if="showState == SHOW_REGISTER" :key="showTrigger">
    <RegisterView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </RegisterView>
  </div>
  <div v-if="showState == SHOW_SELECT_VOICES" :key="showTrigger">
    <SelectVoicesView
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </SelectVoicesView>
  </div>
  <div v-if="showState == SHOW_SELECT_LANGUAGE" :key="showTrigger">
    <SelectLanguageView
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </SelectLanguageView>
  </div>

  <div v-if="showState == SHOW_RECOGNIZER_DEMO" :key="showTrigger">
    <RecognizerDemoView
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </RecognizerDemoView>
  </div>
  <div v-if="showState == SHOW_LICHESS_MENU" :key="showTrigger">
    <LichessMenuView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessMenuView>
  </div>
  <div v-if="showState == SHOW_LICHESS_CHALLENGE" :key="showTrigger">
    <LichessChallengeView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessChallengeView>
  </div>
  <div v-if="showState == SHOW_LICHESS_FRIENDS" :key="showTrigger">
    <LichessFriendView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessFriendView>
  </div>
   <div v-if="showState == SHOW_LICHESS_ARENA" :key="showTrigger">
    <LichessArenaView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessArenaView>
  </div>
   <div v-if="showState == SHOW_LICHESS_OPEN_GAMES" :key="showTrigger">
    <LichessOpenView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessOpenView>
  </div>
  <div v-if="showState == SHOW_LICHESS_PLAY" :key="showTrigger">
    <LichessPlayView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  @string-to-speak="stringToSpeak"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessPlayView>
  </div>
  <div v-if="showState == SHOW_LICHESS_CONNECT" :key="showTrigger">
    <LichessConnectView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessConnectView>
  </div>
  <div v-if="showState == SHOW_SUBSCRIBE" :key="showTrigger">
    <SubscribeBlurbView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </SubscribeBlurbView>
  </div>
  <div v-if="showState == SHOW_LANDING_PAGE" :key="showTrigger">
    <DisplayLandingPageView
     @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </DisplayLandingPageView>
  </div>
  <div v-if="showState == SHOW_PASSWORD_RESET" :key="showTrigger">
    <PasswordResetView
     @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </PasswordResetView>
  </div>
  <div v-if="showState == SHOW_NEW_LANDING_PAGE || showState == SHOW_NEW_LANDING_PAGE_FROM_MAIN" :key="showTrigger">
    <NewLandingPageView
     @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :fromMainPage="showState == SHOW_NEW_LANDING_PAGE_FROM_MAIN"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </NewLandingPageView>
  </div>
  <div v-if="showState == SHOW_EMAIL_VERIFIED" :key="showTrigger">
    <EmailVerifiedView
     @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </EmailVerifiedView>
  </div>
  <div v-if="showState == SHOW_STRIPE_CANCEL" :key="showTrigger">
    <StripeCancelView
     @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </StripeCancelView>
  </div>
    <div v-if="showState == SHOW_STRIPE_SUCCESS" :key="showTrigger">
    <StripeSuccessView
     @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </StripeSuccessView>
  </div>
</template>

// https://stackoverflow.com/questions/61396466/how-to-disable-a-vuejs-router-link

<script setup>

  import { setInterval, setTimeout, clearInterval, clearTimeout } from 'requestanimationframe-timer';

  import TopLine from '@/components/TopLine.vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { ref, watch, onMounted, onUnmounted } from 'vue'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { doStartupCheck } from '@/composables/startupCheck.js'

  import { translateEnglishWords, translateForeignWords, setTranslationLanguage, translatePhrase } from '@/composables/translation';
  import { getCompleteWordlist } from "@/composables/translationText";

  import MainMenuView from '@/views/MainMenuView.vue';
  import EngineMenuView from '@/views/Engines/EngineMenuView.vue';
  import VerbalPlayView from '@/views/Engines/VerbalPlayView.vue';
  import GameHistoryView from '@/views/Engines/GameHistoryView.vue';
  import GameReviewView from '@/views/Engines/GameReviewView.vue';
  import AccountMenuView from '@/views/Account/AccountMenuView.vue';
  import LichessMenuView from '@/views/Lichess/LichessMenuView.vue';
  import LichessChallengeView from '@/views/Lichess/LichessChallengeView.vue';
  import LichessFriendView from '@/views/Lichess/LichessFriendView.vue';
  import LichessArenaView from '@/views/Lichess/LichessArenaView.vue';
  import LichessOpenView from '@/views/Lichess/LichessOpenView.vue';
  import LichessPlayView from '@/views/Lichess/LichessPlayView.vue';
  import LichessConnectView from '@/views/Lichess/LichessConnectView.vue';

  import LoginView from '@/views/Account/LoginView.vue';
  import LogoffView from '@/views/Account/LogoffView.vue';
  import RegisterView from '@/views/Account/RegisterView.vue';
  import SelectVoicesView from '@/views/Account/SelectVoicesView.vue';
  import VoicesMenuView from '@/views/Account/VoicesMenuView.vue';
  import SelectLanguageView from '@/views/Account/SelectLanguageView.vue';
  import SubscribeBlurbView from '@/views/SubscribeBlurbView.vue';
  import StartASRView from '@/views/StartASRView.vue';
  import DisplayLandingPageView from '@/views/DisplayLandingPageView.vue';
  import NewLandingPageView from '@/views/NewLandingPageView.vue';

  import PasswordResetView from '@/views/Urlactions/PasswordResetView.vue';

  import {  Recognizer } from "vosk-browser"

  import Crunker from 'crunker';
  import BoardPreferencesView from '@/views/Account/BoardPreferencesView.vue';
  import EmailVerifiedView from '@/views/Urlactions/EmailVerifiedView.vue';
  import StripeCancelView from '@/views/Urlactions/StripeCancelView.vue';
  import StripeSuccessView from '@/views/Urlactions/StripeSuccessView.vue';
  import RecognizerDemoView from '@/views/Account/RecognizerDemoView.vue';

  const crunker = ref(null);
  const welcomeMp3 = 'https://www.chessvis.com/sounds/welcome_to_verbal_chess.mp3'
  const verbalMp3 = 'https://www.chessvis.com/sounds/ivanna_verbal.mp3'

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()
  
  // language. if user selected "system" -- empty, then grab the default -- unless not supported
  var languageInUse = connectionStore.getLanguageIncludingSystem
  //console.log("system lanaguage",languageInUse)
  if (languageInUse == "") {
    const userPreferredLanguage = navigator.language;
    const language2char = userPreferredLanguage.slice(0, 2)
    const systemLanguage = (language2char != "en" && language2char != "es" &&
                            language2char != "it" && language2char != "de" &&
                            language2char != "fr" && language2char != "pt") 
                            ? "en" : language2char
    languageInUse = systemLanguage
  }
  //console.log("******* language in use",languageInUse)
  connectionStore.setLanguageInUse(languageInUse)
  setTranslationLanguage(languageInUse)

  // force startup info read on program restart
  connectionStore.setLastStartupDate("0")
  
  const windowSizeRef = ref({})
  windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)

  const wordsSaid = ref("")
  const wordsSaidTrigger = ref(0)

  // speaking
  var voices = []
  var engineVoiceNumber = -1
  var playerVoiceNumber = -1

  const showTrigger = ref(0)

  const SHOW_START_ASR = 99

  const SHOW_MAIN = 0
  const SHOW_ENGINE_MENU = 1
  const SHOW_VERBAL_PLAY = 2
  const SHOW_GAME_HISTORY = 3
  const SHOW_GAME_REVIEW = 4

  const SHOW_ACCOUNT_MENU = 10
  const SHOW_SELECT_VOICES = 11
  const SHOW_LOG_ON = 12
  const SHOW_REGISTER = 13
  const SHOW_LOG_OFF = 14
  const SHOW_BOARD_PREFERENCES = 15
  const SHOW_VOICES_MENU = 16
  const SHOW_SELECT_LANGUAGE = 17
  const SHOW_RECOGNIZER_DEMO = 18

  const SHOW_LICHESS_MENU = 20
  const SHOW_LICHESS_CHALLENGE = 21
  const SHOW_LICHESS_FRIENDS = 22
  const SHOW_LICHESS_ARENA = 23
  const SHOW_LICHESS_OPEN_GAMES = 24
  const SHOW_LICHESS_PLAY = 25
  const SHOW_LICHESS_CONNECT = 26

  const SHOW_SUBSCRIBE = 30
  const SHOW_LANDING_PAGE = 31
  const SHOW_NEW_LANDING_PAGE = 32
  const SHOW_NEW_LANDING_PAGE_FROM_MAIN = 33

  const SHOW_PASSWORD_RESET = 40
  const SHOW_STRIPE_CANCEL = 41
  const SHOW_STRIPE_SUCCESS = 42
  const SHOW_EMAIL_VERIFIED = 43

  const showState = ref(SHOW_START_ASR)

   const urlParams =  new URLSearchParams(window.location.search)
  //console.log("***** URL Parameters",urlParams)

  var urlAction = null
  // testing
  //urlAction = "stripe_cancel"
  //urlAction = "stripe_success"
  //urlAction = "passwordreset"
  //urlAction = "emailverified"
  // localStorage.setItem("url_v","NzY2NTcyNjk2Njc5MjAyMA--OGZjMWI0NGMwNzFkMjE0ZDZkMmQ5M2Q1YWQ3MzQ1MWIxZTMxZTg4ZQ--")
  // localStorage.setItem("url_e","henry@conceptual.com")

  //localStorage.setItem("url_v","NzY2NTcyNjk2Njc5MjAyMA--ZWIyZDY1NTdlNzU4MzYyOTdjODg3OTkyZGI4N2I0YTViYmM4NTlmNQ--")
  //localStorage.setItem("url_e","henry%40conceptual.com")

  if (urlParams.size > 0) {
    var parametersToDelete = []
    for (const [key, value] of urlParams.entries()) {
      parametersToDelete.push(key)
      if (key == "a")
        urlAction = value
      localStorage.setItem("url_" + key,value)
    }
    // clear the browser line
    const subdir = (process.env.NODE_ENV === 'production') ? "/" : "/"
    history.replaceState(null, "", subdir);
  }
  else {
    // no url options
    localStorage.setItem("url_a","")
  }

  const startASRStatus = ref("start")
  const startASRStatusTrigger = ref(0)

  // show login, register message when coming back to main screen
  const mainScreenMessage = ref("")

  var recognizer = null
  const sampleRate = 48000;
  var mediaStream = null
  var channel = null
  var audioContext = null
  var microphoneIsMuted = false

  console.log("show state here",showState.value)

  function sendReady() {
    //console.log("send ready with delay");
    startASRStatus.value = "ready"
    startASRStatusTrigger.value++
  }

  // **** START Computer Speaking Routines

  function pickVoices(voices) {

    console.log("in pick voices")

    var playerVoiceNumber = -1
    var engineVoiceNumber = -1
    var samantha = -1
    var daniel = -1
    var googleUS = -1
    var googleUK = -1

    const playerVoiceName = connectionStore.getPlayerVoiceName
    const playerVoiceLang = connectionStore.getPlayerVoiceLang
    const opponentVoiceName = connectionStore.getOpponentVoiceName
    const opponentVoiceLang = connectionStore.getOpponentVoiceLang

    //console.log("player voice stored info",languageInUse,playerVoiceName,playerVoiceLang)
    //console.log("opponent voice stored info",languageInUse,opponentVoiceName,opponentVoiceLang)

    for (var i=0; i < voices.length; i++) {
      const oneVoice = voices[i]

      if (!oneVoice.lang.startsWith(languageInUse))
        continue;

      //console.log("VOICE",i, oneVoice)

      // look for the user selected voices
      if (playerVoiceLang == oneVoice.lang && playerVoiceName == oneVoice.name)
        playerVoiceNumber = i
      if (opponentVoiceLang == oneVoice.lang && opponentVoiceName == oneVoice.name)
        engineVoiceNumber = i
      if (playerVoiceNumber >= 0 && engineVoiceNumber >= 0)
        break

      // find the default voices
      switch (languageInUse) {
        case "en" :
          if ((oneVoice.name.includes("Samantha") || oneVoice.name.includes("Ava") || 
                      oneVoice.name.includes("Allison") || oneVoice.name.includes("Nicky"))
                  && oneVoice.lang == "en-US" && samantha == -1)
            samantha = i
          else
          if ((oneVoice.name.includes("Daniel") || oneVoice.name.includes("Oliver")) 
                    && oneVoice.lang == "en-GB" && daniel == -1)
            daniel = i
          else
          if (oneVoice.name.includes("Google US English") && oneVoice.lang == "en-US" && googleUS == -1)
            googleUS = i
          else
          if (oneVoice.name.includes("Google UK English Female") && oneVoice.lang == "en-GB" && googleUK == -1)
            googleUK = i
          break
        case "es" :
            if ((oneVoice.name.includes("Mónica"))
                  && oneVoice.lang == "es-ES" && samantha == -1)
            samantha = i
          else
          if ((oneVoice.name.includes("Paulina")) 
                    && oneVoice.lang == "es-MX" && daniel == -1)
            daniel = i
          break
      }
    }

    if (playerVoiceNumber == -1) {
      if (samantha > -1)
        playerVoiceNumber = samantha
      else
      if (googleUS > -1)
        playerVoiceNumber = googleUS
    }

    if (engineVoiceNumber == -1) {
      if (daniel > -1)
        engineVoiceNumber = daniel
      else
        if (googleUK > -1)
          engineVoiceNumber = googleUK
    }
    return ([playerVoiceNumber,engineVoiceNumber])
  }

  function getListofVoices(voicesFoundCallback) {
    console.log("in get list of voices")
    voices = []
    // https://stackoverflow.com/questions/21513706/getting-the-list-of-voices-in-speechsynthesis-web-speech-api/22978802#22978802

    const allVoicesObtained = new Promise(function(resolve, reject) {
      voices = window.speechSynthesis.getVoices();
      if (voices.length !== 0) {
        console.log("before resolve with voices found")
        resolve(voices);
        console.log("after resolve")
      } 
      else {
        console.log("add event listener")
        window.speechSynthesis.addEventListener("voiceschanged", function() {
          voices = window.speechSynthesis.getVoices();
          resolve(voices);
        });
      }
    });

    allVoicesObtained.then(voices => {
      console.log("in allvoicesobtained.then")
      const voiceNumbers = pickVoices(voices)
      console.log("voice numbers in all voices obtained",voiceNumbers[0],voiceNumbers[1] )
      voicesFoundCallback(voices,voiceNumbers[0],voiceNumbers[1])
    })
  }

  function handleVoicesCallback(voices1,playerNumber,engineNumber) {
    console.log("VOICE NUMBERS in handle voice callback",playerNumber,engineNumber)
    playerVoiceNumber = playerNumber
    engineVoiceNumber = engineNumber
    voices = voices1
  }

  function setMicrophoneState(muteMicrophone) {
    console.log("stream in mute",mediaStream)
    if (mediaStream == null)
      return
    const audioTracks = mediaStream.getAudioTracks();
    audioTracks.forEach(function(track) {
        track.enabled = !muteMicrophone
    });
    //console.log("*** microphone mute state", muteMicrophone)
  }

    const mixAndPlayAudio = async () => {
      if (!crunker.value) return;

      try {

        const URL = "https://www.chessvis.com/sounds/"
        const names = ["alice_welcome.mp3","alice_to.mp3","alice_verbal.mp3","alice_chess.mp3"]
        var audioBuffers = []

        for (var i=0; i < names.length; i++) {
          const filename = URL + names[i]
          const audioBufferArray = await crunker.value.fetchAudio(filename); 
          //console.log("audiobuffer",i,filename,audioBufferArray) 
          audioBuffers.push(audioBufferArray[0])
        }
       
        //console.log("LENGTH Of audioBuffers",audioBuffers.length)
        const mixed = await crunker.value.concatAudio(audioBuffers);
        crunker.value.play(mixed);
      } catch (error) {
        console.error("Error mixing audio:", error);
      }
    };

  function speakMp3() {
    mixAndPlayAudio()
  }

  function voiceAddMicrophoneSupport(msg) {
    console.log("in voice add microphone")
    msg.onstart = () => { 
      console.log('Speech started');
      setMicrophoneState(true)
    }
    msg.onend = () => {
        console.log('Speech ended');
        setMicrophoneState(false)
    }
    msg.onerror = (event) => {
      console.error('Speech error:', event.error);
      setMicrophoneState(false)
    }
    msg.onpause = () => {
      console.log('Speech paused');
      setMicrophoneState(false)
    }
    msg.onresume = () => {
      console.log('Speech resumed');
      setMicrophoneState(false)
    }
  }

  function stringToSpeak(usePlayerVoice,whatToSay) {
    console.log("********** STRING",usePlayerVoice,whatToSay,audioContext.state)

    audioContext.resume().then(() => {
      console.log("attempt to resume",audioContext.state)
    });
    const useMp3 = false

    if (useMp3) {
      mixAndPlayAudio()
      return
    }
  
    const rate = 0.9
    const voiceNumber = (usePlayerVoice) ? playerVoiceNumber : engineVoiceNumber

    //console.log("speech synthesis supported",whatToSay,voiceNumber)
    var msg = new SpeechSynthesisUtterance()
    voiceAddMicrophoneSupport(msg)
    msg.rate = rate
    if (voiceNumber >= 0)
      msg.voice = voices[voiceNumber]
    msg.text = whatToSay
    window.speechSynthesis.speak(msg)

  }

  // **** END Computer Speaking Routines

  async function initAudioContext(firstCall) {
   
      console.log("init audio context",firstCall,audioContext.state)

      await audioContext.audioWorklet.addModule('recognizer-processor.js')

      const recognizerProcessor = new AudioWorkletNode(
        audioContext, 
        'recognizer-processor', 
        { channelCount: 1, numberOfInputs: 1, numberOfOutputs: 1 });

      recognizerProcessor.port.postMessage(
       {action: 'init', recognizerId: recognizer.id}, [ channel.port2 ])
      
      recognizerProcessor.connect(audioContext.destination);

      const source = audioContext.createMediaStreamSource(mediaStream);
      source.connect(recognizerProcessor);

      console.log("AudioContext Sample Rate:", audioContext.sampleRate);

      startASRStatus.value = "audioDone"
      startASRStatusTrigger.value++

      getListofVoices(handleVoicesCallback)

      console.log("Audio Done")
  }

  // taken from the chessvis code for voice within the learn with coach

  const getAudioPermissions = async () => {

    const constraints = { video: false, audio: true,}

    if (!navigator.mediaDevices.getUserMedia) {
      alert(translatePhrase('Your browser does not support getUserMedia API'));
      initVosk()
      return;
    }

    try {
      mediaStream = await navigator.mediaDevices.getUserMedia(constraints);
    } catch(error) {
        alert(translatePhrase('Your browser has blocked Verbal Chess from using the microphone'));
        initVosk()
        return
    }

    console.log("END OF getAudioPermissions")
    initVosk()
  }

  async function initVosk() {
      
    var modelName = ""

    console.log("**** in init !")

    channel = new MessageChannel();

    startASRStatus.value = "downloading"
    startASRStatusTrigger.value++

    // define where the program should be stored
    modelName = (connectionStore.getUseVerbalWebsite) ? 
                            "https://www.verbalchess.fun/" :
                            "https://www.chessvis.com/verbal2/"         
                    
    switch (languageInUse) {
      case "de" :
        modelName += "vosk-model-small-de-0.15.zip"
        break
      case "fr" :
        modelName += "vosk-model-small-fr-0.22.zip"
        break
      case "it" :
        modelName += "vosk-model-small-it-0.22.zip"
        break
      case "es" :
        modelName += "vosk-model-small-es-0.42.zip"
        break
      case "pt" :
        modelName += "vosk-model-small-pt-0.3.zip"
        break
      default :
        modelName += "model.tar.gz"
        break
    }

    console.log("create model",modelName)
    
    const model = await Vosk.createModel(modelName);

    model.registerPort(channel.port1);

    recognizer = new model.KaldiRecognizer(sampleRate,JSON.stringify(["",'[unk]']));

    //recognizer = new model.KaldiRecognizer(sampleRate,JSON.stringify(["cat dog rabbit",'[unk]']));
    //recognizer.setGrammar(JSON.stringify(["apple pear peach",'[unk]']),sampleRate)

    // if in development, feed complete list in at beginning
    if (process.env.NODE_ENV !== 'production') {
      const completeWordList = getCompleteWordlist()
      newWordList(completeWordList)
    }
    
    recognizer.setWords(true);

    recognizer.on("result", (message) => {
        const result = message.result;
        // console.log(JSON.stringify(result, null, 2));
        const textNative = result['text']
        if (textNative == "")
          return
        console.log("TEXT NATIVE",textNative)

        // code to dump the heard speech just above the toolbar
        // const element = document.getElementById("speech_text")
        // if (element != null)
        //   element.textContent = textNative

        const text = translateForeignWords(textNative)
        console.log("*** RESULT ",text,showState.value)

        if (microphoneIsMuted) {
          if (text == "command listen") {
              wordsSaid.value = (showState.value == SHOW_RECOGNIZER_DEMO) ? 
                          text + "," + textNative : text
              wordsSaidTrigger.value++
          }
        }   
        else
          if (text != "" && text != "[unk]") {
                  console.log("**********************.  result",text)
                  wordsSaid.value = (showState.value == SHOW_RECOGNIZER_DEMO) ? 
                          text + "," + textNative : text
                  wordsSaidTrigger.value++
                  console.log("text sent back",wordsSaid.value)
          }
    });
    // recognizer.on("partialresult", (message) => {
    //     const partial = message.result.partial;
    //      console.log("*** PARTIAL ",partial)
    // });
    
    startASRStatus.value = "downloaded"
    startASRStatusTrigger.value++

    console.log("**** READY !")
    
    try {

      console.log("before getTracks media devices")
      const audioTracks = mediaStream.getTracks().find(track => track.kind === 'audio')

      console.log("audio tracks",audioTracks)
      const audioTrack = mediaStream.getAudioTracks()[0];
      console.log("audio track zero ",audioTrack)
      const trackSettings = audioTrack.getSettings();
      console.log("track settings",trackSettings)
      const sampleRate = trackSettings.sampleRate;
      console.log("Audio Sample Rate:", sampleRate);

      // You can also use the AudioContext's sampleRate if you're processing the audio
      // const audioContext = new AudioContext();
      // const source = audioContext.createMediaStreamSource(stream);
      // console.log("AudioContext Sample Rate:", audioContext.sampleRate);
    
      // trying the simpler approach above.
      // mediaStream = await navigator.mediaDevices.getUserMedia({
      //     video: false,
      //     audio: {
      //         echoCancellation: true,
      //         noiseSuppression: true,
      //         channelCount: 1,
      //         sampleRate
      //     },
      // });
    }
    catch (e) {
      console.log("ERROR ",e)
    }

    if (mediaStream != null) {
      startASRStatus.value = "mic"
      startASRStatusTrigger.value++
      const timeoutId = setTimeout(sendReady, 200);
    }
    else {
      startASRStatus.value = "no_mic"
      startASRStatusTrigger.value++
      console.log("no media stream")
    }

    //showState.value = SHOW_MAIN
  }

  function createAudioContext() {
    console.log("in create audio context")
    audioContext = new AudioContext();
    audioContext.onerror = function(event) {
      console.error("*************** AudioContext error:", event);    
      alert(translatePhrase("Audio Context error. If you're using the 'Chrome' browser on Android, please try another browser. 'Verbal Chess' won't respond to voice commands but you can still tap and click"))
      startASRStatus.value = "audioDone"
      startASRStatusTrigger.value++
      // Implement error handling or recovery logic here
    };
    console.log("audio context",audioContext)
  }

  function startAudioContext() {
    // console.log("start crunker")
    // crunker.value = new Crunker();
    console.log("Start Audio Context")
 
    initAudioContext(true)
  }

  function newWordList(wordList) {
    console.log("***************************  new word list",wordList)
    const translatedWordlist = translateEnglishWords(wordList,true)
    console.log("***************************  translated new word list",translatedWordlist)
    if (recognizer != null)
      recognizer.setGrammar(JSON.stringify([translatedWordlist,'[unk]']),sampleRate)
  }

  function setMicrophoneIsMuted(isMuted) {
    console.log("************** set microphone status",isMuted)
    microphoneIsMuted = isMuted
  }


  window.onerror = function(message, source, lineno, colno, error) {
    // Handle the error here
    // Returning true prevents the default browser error message (in older browsers)
    //console.log("got window ONERROR", message)

    return false; 
  };

  // window.addEventListener('error', e => {

  //   // Get the error properties from the error event object
  //   const { message, filename, lineno, colno, error } = e; 
  //   console.log("got window error", message)
  // });

  function whereNext(destination) {
    //console.log("******* Destination ",destination)
    switch (destination) {
      case "initAudio" :
        startAudioContext();
        break
      case "/main_from_login" :
        mainScreenMessage.value = "login"
        showState.value = SHOW_MAIN
        break
      case "/main_from_register" :
        mainScreenMessage.value = "register"
        showState.value = SHOW_MAIN
        break
      case "/" :
        mainScreenMessage.value = ""
        showState.value = SHOW_MAIN
        break
      case "/main_or_urlaction" :
        // ASR is up, was there an action on the URL?  (This is used first time through)
        console.log("*** ASR is done ****")
        mainScreenMessage.value = ""
        if (urlAction == null) {
          showState.value = SHOW_MAIN
          break
        }
        switch (urlAction) {
          case "stripe_cancel" :
            showState.value = SHOW_STRIPE_CANCEL
            break
          case "stripe_success" :
            showState.value = SHOW_STRIPE_SUCCESS
            break
          case "emailverified" :
            showState.value = SHOW_EMAIL_VERIFIED
            break
          case "passwordreset" :
            showState.value = SHOW_PASSWORD_RESET
            break
          default :     // landing or play is okay to go to main
            showState.value = SHOW_MAIN
            break
        }
        break
      case "/enginemenu" :
        showState.value = SHOW_ENGINE_MENU
        break
      case "/verbalplay" :
        showState.value = SHOW_VERBAL_PLAY
        break
      case "/gamehistory" :
        showState.value = SHOW_GAME_HISTORY
        break
      case "/gamereview" :
        showState.value = SHOW_GAME_REVIEW
        break
      case "/accountmenu" :
        showState.value = SHOW_ACCOUNT_MENU
        break
      case "/boardpreferences" :
        showState.value = SHOW_BOARD_PREFERENCES
        break
      case "/voicesmenu-from-select-voices" :
        pickVoices(voices)
        showState.value = SHOW_VOICES_MENU
        break
      case "/voicesmenu" :
        showState.value = SHOW_VOICES_MENU
        break
      case "/selectlanguage" :
        showState.value = SHOW_SELECT_LANGUAGE
        break
      case "/recognizerdemo" :
        showState.value = SHOW_RECOGNIZER_DEMO
        break
      case "/login" :
        showState.value = SHOW_LOG_ON
        break
      case "/logoff" :
        showState.value = SHOW_LOG_OFF
        break
      case "/register" :
        showState.value = SHOW_REGISTER
        break
      case "/selectvoices" :
        showState.value = SHOW_SELECT_VOICES
        break
      case "/restartasr" :
        location.reload();
        break
      case "/lichessmenu" :
        showState.value = SHOW_LICHESS_MENU
        break
      case "/lichessconnect" :
        showState.value = SHOW_LICHESS_CONNECT
        break
      case "/lichesschallenge" :
        showState.value = SHOW_LICHESS_CHALLENGE
        break
      case "/lichessarena" :
        showState.value = SHOW_LICHESS_ARENA
        break
      case "/lichessfriends" :
        showState.value = SHOW_LICHESS_FRIENDS
        break
      case "/lichessopen" :
        showState.value = SHOW_LICHESS_OPEN_GAMES
        break
      case "/lichessplay" :
        showState.value = SHOW_LICHESS_PLAY
        break

      case "/subscribe" :
        showState.value = SHOW_SUBSCRIBE
        break
      case "/landingpage" :
        //console.log("show landing page")
        showState.value = SHOW_NEW_LANDING_PAGE_FROM_MAIN
        break
      default :
        console.log("******************** unknown route -> ",destination)
        break
    }
    showTrigger.value++
  }
 
  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("new window size",windowSizeRef.value)
  })
  
  const onResizeChange = () => {
    //windowWidth.value = window.innerWidth
    //windowHeight.value = window.innerHeight
    //console.log("**** height changed in app ",window.innerHeight,window.innerWidth)

    /*
    var windowSizeObject = {
      w: window.outerWidth,
      h: window.outerHeight,
      iw: window.innerWidth,
      ih: window.innerHeight
    };
    //console.log("window size", windowSizeObject)
    */
   
    windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)
  }



  onMounted(() => {
    
    //console.log("before onresize add")
    window.addEventListener('resize', onResizeChange)

    //console.log("after add event")
    var element = document.getElementById("app")
    //console.log("app element",element)

    element.style.height = "100vh"
    element.style.width = "100vw"

    // set the background for the page

     // https://ionicframework.com/docs/theming/dark-mode
    // get the system value for darkmode
    // Use matchMedia to check the user preference

    // Add or remove the "dark" class on the document body
    const toggleDarkTheme = (shouldAdd) => {

      var darkString = "light"
      // set by the preferences. could be to use the system or force light/dark
      if (shouldAdd) {
        const darkBoardColors = connectionStore.getDarkBoardColors
        if (darkBoardColors != null) {
          if (darkBoardColors == "chessvis" || darkBoardColors == "lichess")
            darkString = darkBoardColors   
          else
            darkString = "dark"
        }
        else
          darkString = "dark"
      }

      document.body.classList.toggle('dark', shouldAdd);
      connectionStore.setDarkMode(darkString )
    };

    //console.log("before dark theme")
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    toggleDarkTheme(prefersDark.matches);

    //console.log("before add change")
    // Listen for changes to the prefers-color-scheme media query
    prefersDark.addEventListener('change', 
                  (mediaQuery) => toggleDarkTheme(mediaQuery.matches));

    //console.log("**** BEFORE initvosk")
    var startOnLandingPage = connectionStore.getStartOnLandingPage
    const runRequestFromLandingPage = connectionStore.getRunRequestFromLandingPage

    // TESTING -- force the start on landing page
    //startOnLandingPage = "yes"
    console.log("start on landing page",startOnLandingPage,runRequestFromLandingPage)

    // if from chessvis, the cookie and dummy are passed
    if (urlAction == "landing" || urlAction == "play") {
      const url_c = localStorage.getItem("url_c")
      const url_d = localStorage.getItem("url_d")
      if (url_c != null && url_d != null) {
        const c = decodeURIComponent(url_c)
        const d = decodeURIComponent(url_d)
        connectionStore.setUserCookieDummy(c,d)            
      }
      if (urlAction == "play")
        startOnLandingPage = "no"
    }
    
    // once a user plays a game, the "startOn..." flag is set to "no"
    // and the user will start within the program
    // if they haven't played before BUT have come here by wanting to play on the landing page,
    //     then "runrequest..." will be yes
    // there are also two URL actions:  play & landing
    if (urlAction == "landing" || (startOnLandingPage == "yes" && runRequestFromLandingPage != "yes")) {
        showState.value = SHOW_NEW_LANDING_PAGE
    }
    else {
      connectionStore.setRunRequestFromLandingPage("no")
      createAudioContext()
      getAudioPermissions()
      //initVosk()
    }
  })

  onUnmounted(() => window.removeEventListener('resize', onResizeChange))

</script>

<style>

</style>
